import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TContentHubHeroBannerFields, TContentHubHeroBannerProps, TContentHubHeroTextColorParams } from '../types/productHeroBanner.types';
import { TContentHubButton, TRendition } from '../../../types/types';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';

export class ProductHeroBannerModel {
  private readonly fields?: TContentHubHeroBannerFields;
  private readonly params?: TContentHubHeroTextColorParams;
  private readonly rendering?: ComponentRendering;

  constructor(props: TContentHubHeroBannerProps) {
    this.fields = props?.fields;
    this.params = props?.params;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): string | undefined {
    return this.fields?.apiData?.title;
  }

  get description(): string | undefined {
    return appendRootToRichTextInternalLinks(this.fields?.apiData?.description);
  }

  get eyebrow(): string | undefined {
    return this.fields?.apiData?.eyebrow;
  }

  get image(): string | undefined {
    return this.fields?.apiData?.full;
  }

  get desktopSDRendition(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_desktop_size1300;
  }

  get desktopRendition(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_desktop_size1900;
  }

  get mobileRendition(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_mobile_size1000;
  }

  get tabletLandscapeRendition(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_tablet_size1000;
  }

  get tabletRendition(): TRendition | undefined {
    return this.fields?.apiData?.assets?.[0]?.rendition_tablet_size1200;
  }

  get mobileImage(): string | undefined {
    return this.fields?.apiData?.thumbnail;
  }

  get primaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button1;
  }

  get primaryCTAUrl(): string | undefined {
    return appendRootToInternalLink(this.primaryLink?.url);
  }

  get secondaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button2;
  }

  get secondaryCTAUrl(): string | undefined {
    return appendRootToInternalLink(this.secondaryLink?.url);
  }

  get textColor(): string {
    return this.params?.textColor?.toLowerCase() || 'white';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get enableBuildPriceCTA(): boolean | undefined {
    return this.params?.enableBuildPriceCTA === '1';
  }
}
